import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../lib/utils';
// Shared building blocks for the Philadelphia (BHHS Fox & Roach) report.
interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  className?: string;
}
/** Cabernet eyebrow rule + serif title, gentle reveal. */
export function SectionHeading({
  eyebrow,
  title,
  description,
  className
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    ease: [0.22, 1, 0.36, 1]
  }} className={cn('mb-5 max-w-2xl print:mb-3', className)} data-id="element-815" data-mp="2r2x9l5tv9fcp">
      <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-bhhs-cab" data-id="element-816" data-mp="15sgnh67dtlf0">
        <span className="h-px w-6 bg-bhhs-cab" data-id="element-817" data-mp="10tvlp2chetog" />
        {eyebrow}
      </span>
      <h2 className="font-display mt-2.5 text-3xl font-semibold leading-[1.1] tracking-tight text-bhhs-cab print:text-2xl" data-id="element-818" data-mp="7eh83zc9axzm">
        {title}
      </h2>
      {description && <p className="mt-2.5 text-[15px] leading-relaxed text-muted-foreground" data-id="element-819" data-mp="hb2d4koa093g">
          {description}
        </p>}
    </motion.div>;
}